import { render, staticRenderFns } from "./DownloadPage.vue?vue&type=template&id=223811cf&scoped=true"
import script from "./DownloadPage.vue?vue&type=script&lang=js"
export * from "./DownloadPage.vue?vue&type=script&lang=js"
import style0 from "./DownloadPage.vue?vue&type=style&index=0&id=223811cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223811cf",
  null
  
)

export default component.exports